import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GainsFormItemComponent } from '../gains-form-item/gains-form-item.component';

@Component({
  selector: 'gains-time-picker',
  standalone: false,
  templateUrl: './gains-time-picker.component.html',
  styleUrl: './gains-time-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GainsTimePickerComponent),
      multi: true
    }
  ]
})
export class GainsTimePickerComponent extends GainsFormItemComponent implements ControlValueAccessor, OnInit {
  @Input() format = 'hh:mm a';
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setControl();
  }

  onPanelChanged(event: any) {
    if (event === false) {
      this.internalFormControl.markAsTouched();
      this.checkError();
    }
  }

  onValueChange(selectedValue: Date | null) {
    this.checkError();
  }

  registerOnTouched(fn: any): void {
    //required by interface
  }
  registerOnChange(fn: any): void {
    this.internalFormControl?.valueChanges.subscribe(fn);
  }
  setDisabledState(isDisabled: boolean): void {
    if (!this.internalFormControl) return;
    if (isDisabled) {
      this.internalFormControl.disable();
    } else {
      this.internalFormControl.enable();
    }
  }
}
